<template>
  <div>
    <nomenclature-form
      :create="create"
      :view="view"
      :change="change"
      @close="$router.push('/admin/nomenclature/list')"
      @list="$router.push('/admin/nomenclature/list')"
      @change="id=> $router.push('/admin/nomenclature/change?id=' + id)"
      @view="id=> $router.push('/admin/nomenclature/view?id=' + id)"
    />
  </div>
</template>
<script >

import NomenclatureForm from "@/views/admin/components/Nomenclature-form.vue"

export default {
  components: { NomenclatureForm },
  props: ['create', 'change', 'view'],
  mounted () {
    console.log('Nomenclature-page.vue is loaded')
  },
}
</script>

<style scoped>

</style>
